import { wrapMiddlewaresWithSentry } from '@sentry/tanstackstart-react';
import {
  sentryGlobalFunctionMiddleware,
  sentryGlobalRequestMiddleware,
} from '@sentry/tanstackstart-react'
import { createCsrfMiddleware, createStart } from '@tanstack/react-start'

const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === 'serverFn',
})

// Sentry middleware MUST be first in each array so it wraps every other
// middleware and captures their errors. Note: SSR render exceptions are NOT
// caught here — those are handled by wrapFetchWithSentry in src/server.ts and,
// for React error boundaries, by manual captureException (see Task 5, optional).
export const startInstance = createStart(() => {
  return {
    requestMiddleware: wrapMiddlewaresWithSentry({ sentryGlobalRequestMiddleware, csrfMiddleware }),
    functionMiddleware: wrapMiddlewaresWithSentry({ sentryGlobalFunctionMiddleware }),
  }
})
